import {
  DISCOVER_RATES_FETCH_DATA,
  DISCOVER_RATES_ENABLE_LOADING,
  DISCOVER_RATES_DISABLE_LOADING,
  DISCOVER_RATES_FETCH_ERROR,
  DISCOVER_RATES_SET_SEARCH_FILTERS,
  DISCOVER_RATES_SET_FILTERS,
  DISCOVER_RATES_RESET_FILTERS,
  DISCOVER_RATES_SET_SORT_BY_FILTERS,
  DISCOVER_RATES_FETCH_FILTERS,
  DISCOVER_RATES_ENABLE_FILTERS_LOADING,
  DISCOVER_RATES_DISABLE_FILTERS_LOADING,
  DISCOVER_RATES_SET_GRID_PORTS,
  DISCOVER_RATES_FETCH_GRID_DATA,
  DISCOVER_RATES_SET_SEARCH_RESULTS,
  DISCOVER_RATES_SET_GRID_FILTERS_RANGE,
  DISCOVER_RATES_SET_GRID_LOADING,
  DISCOVER_RATES_RESET_PORT_LIST,
  RESET_PREFILL_DATA,
} from 'src/actions/constants';
import { Currency } from 'src/components/common/Types/CommonTypes';
import {
  rateDigitisationDiscoverRates,
  rateDigitisationDiscoverRatesGetFilters,
  fetchDiscoverSellRates,
} from 'src/api/discoverRates';
import { isValidArray, isValidString } from 'src/Library/Helper';
import { RATE_DIGITISATION_DISCOVER_RATES_SEARCH, RATE_DIGITISATION } from 'src/api/routes';
import { API_BASE_URL } from 'src/globals';
import { getAuthenticationHeaders } from 'src/api/utils';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { GridView } from 'src/components/pages/DiscoverRate/DiscoverRateUtils';
import { v4 as uuid } from 'uuid';
import { ModesOfService } from 'src/Library/Constants';
export const resetPortList = (val) => async (dispatch) => {
  dispatch({
    type: DISCOVER_RATES_RESET_PORT_LIST,
    data: val,
  });
};
export const setSearchFilterValues = (val) => async (dispatch) => {
  dispatch({
    type: DISCOVER_RATES_SET_SEARCH_FILTERS,
    data: val,
  });
};
export const setGridPorts = (val) => (dispatch) => {
  dispatch({
    type: DISCOVER_RATES_SET_GRID_PORTS,
    data: val,
  });
};
export const setGridFiltersRange = (val) => (dispatch) => {
  dispatch({
    type: DISCOVER_RATES_SET_GRID_FILTERS_RANGE,
    data: val,
  });
};
export const fetchFilters = () => async (dispatch, getState) => {
  const { searchFilters, fetchedFilters } = getState().discoverRatesReducer;
  const { pol, pod, incoterm, movementType } = searchFilters;
  const containerList = JSON.parse(searchFilters.container || '[]');
  const cargoList = JSON.parse(searchFilters.cargo || '[]');
  if (isEmpty(fetchedFilters)) {
    const body = {
      polId: pol?.id,
      podId: pod?.id,
      container: containerList?.key,
      cargo: cargoList?.key,
      mode: 'FCL',
      view: 'BUY',
      ...((incoterm && movementType) && { 
        incoterm, 
        movementType, 
      })
    };
    dispatch({
      type: DISCOVER_RATES_ENABLE_FILTERS_LOADING,
    });
    const response = await rateDigitisationDiscoverRatesGetFilters(body);
    if (!response.isSuccess) {
      dispatch({
        type: DISCOVER_RATES_FETCH_ERROR,
        data: response.errorMessage,
      });
    } else {
      dispatch({
        type: DISCOVER_RATES_FETCH_FILTERS,
        data: response.data,
      });
    }
    dispatch({
      type: DISCOVER_RATES_DISABLE_FILTERS_LOADING,
    });
  }
};
export const fetchGridData = (isPrimary = false) => (dispatch, getState) => {
  const { gridPorts, searchFilters } = getState().discoverRatesReducer;
  const containerList = JSON.parse(searchFilters.container || '[]');
  const cargoList = JSON.parse(searchFilters.cargo || '[]');
  const { POLList, PODList } = gridPorts;
  const sortByFilters = getState().discoverRatesReducer.sortByFilters;

  const polPodLoadingState = {};
  if (isValidArray(POLList) && isValidArray(PODList)) {
    for (let i = 0; i < POLList?.length; i = i + 1) {
      for (let j = 0; j < PODList?.length; j = j + 1) {
        polPodLoadingState[`${POLList[i].dbId}-${PODList[j].dbId}`] = {
          isLoading: true,
          data: [],
          error: null,
        };
      }
    }
    dispatch({
      type: DISCOVER_RATES_SET_GRID_LOADING,
      data: polPodLoadingState,
    });
    for (let i = 0; i < POLList.length; i = i + 1) {
      for (let j = 0; j < PODList.length; j = j + 1) {
        fetch(`${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_DISCOVER_RATES_SEARCH}`, {
          method: 'POST',
          body: JSON.stringify({
            isPrimary,
            polId: POLList[i].dbId,
            podId: PODList[j].dbId,
            container: containerList?.key,
            cargo: cargoList?.key,
            mode: 'FCL',
            view: searchFilters.view,
            priceTrendsIntervalInMonths: 12,
            ...(isPrimary && {
              uuid: uuid(),
            }),
            ...sortByFilters,
          }),
          headers: {
            ...getAuthenticationHeaders(),
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.status === 400) {
              return response.json();
            }
            if (response.ok) {
              return response.json();
            } else {
              throw new Error(response.statusText);
            }
          })
          .then((response: any) => {
            if (response.error) {
              dispatch({
                type: DISCOVER_RATES_FETCH_GRID_DATA,
                data: {
                  [`${POLList[i].dbId}-${PODList[j].dbId}`]: {
                    isLoading: false,
                    data: [],
                    error: response.error.message,
                  },
                },
              });
            } else {
              let minFreightSearchResult;
              let minFreightPriceContainer = response.data?.freightPrice?.min;
              response.data?.searchResults?.forEach((item) => {
                if (item.totalFreight?.amount === minFreightPriceContainer) {
                  minFreightSearchResult = item;
                }
              });
              dispatch({
                type: DISCOVER_RATES_FETCH_GRID_DATA,
                data: {
                  [`${POLList[i].dbId}-${PODList[j].dbId}`]: {
                    isLoading: false,
                    data: response.data,
                    fetchedResultWithFilters: response.data.searchResults,
                    ...(minFreightSearchResult && {
                      minFreightSearchResult,
                    }),
                  },
                },
              });
            }
          })
          .catch((error) => {
            dispatch({
              type: DISCOVER_RATES_FETCH_GRID_DATA,
              data: {
                [`${POLList[i].dbId}-${PODList[j].dbId}`]: {
                  isLoading: false,
                  data: [],
                  error: error.message,
                },
              },
            });
          });
      }
    }
  }
};
export const getAllDataSetSortByFilter = (val, apiCall = true) => async (dispatch, getState) => {
  dispatch({
    type: DISCOVER_RATES_SET_SORT_BY_FILTERS,
    data: val,
  });
  if (apiCall) await dispatch(fetchAllData({}));
  const { selectedFilters } = getState().discoverRatesReducer;
  const ffIdsList = selectedFilters?.ffIdsList;
  const carrierList = selectedFilters?.carrierList;
  if (isValidArray(ffIdsList) || isValidArray(carrierList)) {
    setFFAndCarrierFilters(undefined, dispatch, getState);
  }
};
const applyGridFilters = (val, selectedFilters, portList, dispatch) => {
  const viewRates = val?.rateType || selectedFilters?.rateType;
  const validityEnd = val?.validityEnd || selectedFilters?.validityEnd;
  const route = val?.route || selectedFilters?.route;
  const carrierList = val?.carrierList || selectedFilters?.carrierList;
  const freightPrice = val?.freightPrice || selectedFilters?.freightPrice;
  const transitDays = val?.transitDays || selectedFilters?.transitDays;
  let ports = {
    ...portList,
  };
  Object.keys(portList).map((key) => {
    ports[key].viewRatesResult = ports[key].fetchedResultWithFilters;
    if (isValidArray(viewRates)) {
      ports[key].viewRatesResult = ports[key].viewRatesResult?.filter(
        (item) => viewRates.indexOf(item.type) !== -1
      );
    }
    if (isValidString(validityEnd)) {
      ports[key].viewRatesResult = ports[key].viewRatesResult?.filter(
        (item) => item.validityEnd >= moment(validityEnd)
      );
    }
    if (isValidArray(route)) {
      ports[key].viewRatesResult = ports[key].viewRatesResult?.filter(
        (item) =>
          (route.indexOf('DIRECT') !== -1 && item.isDirect) ||
          (route.indexOf('TRANSSHIPMENT') !== -1 && isValidArray(item.transshipments))
      );
    }
    if (isValidArray(carrierList)) {
      ports[key].viewRatesResult = ports[key].viewRatesResult?.filter(
        (item) => carrierList.indexOf(item.carrier?.id?.toString()) !== -1
      );
    }
    if (!isEmpty(freightPrice)) {
      ports[key].viewRatesResult = ports[key].viewRatesResult?.filter(
        (item) =>
          Math.round(item.totalFreight?.amount) >= freightPrice.min &&
          Math.round(item.totalFreight?.amount) <= freightPrice.max
      );
    }
    if (!isEmpty(transitDays)) {
      ports[key].viewRatesResult = ports[key].viewRatesResult?.filter(
        (item) =>
          item.transitDays !== null &&
          item.transitDays >= transitDays.min &&
          item.transitDays <= transitDays.max
      );
    }
    const minFreightSearchResult = isValidArray(ports[key].viewRatesResult)
      ? ports[key].viewRatesResult?.reduce((prev, curr) =>
          prev.totalFreight?.amount < curr.totalFreight?.amount ? prev : curr
        )
      : [];
    dispatch({
      type: DISCOVER_RATES_FETCH_GRID_DATA,
      data: {
        [key]: {
          fetchedResultWithFilters: ports[key].fetchedResultWithFilters,
          data: {
            ...ports[key].data,
            searchResults: ports[key].viewRatesResult,
          },
          ...(minFreightSearchResult && {
            minFreightSearchResult,
          }),
        },
      },
    });
  });
};
export const getAllDataSetFilter = (val, apiCall = true) => async (dispatch, getState) => {
  dispatch({
    type: DISCOVER_RATES_SET_FILTERS,
    data: val,
  });
  if (apiCall) await dispatch(fetchAllData({isSearch: false, resetFreight: !!val.noOfContainers}));
  setFFAndCarrierFilters(val, dispatch, getState);
};

const setFFAndCarrierFilters = (val, dispatch, getState) => {
  const {
    fetchedResultWithFilters,
    selectedFilters,
    searchFilters,
    portList,
  } = getState().discoverRatesReducer;
  let searchResults = fetchedResultWithFilters;
  const ffIdsList = val?.ffIdsList || selectedFilters?.ffIdsList;
  const carrierList = val?.carrierList || selectedFilters?.carrierList;
  if (searchFilters.viewType === GridView.GRID) {
    applyGridFilters(val, selectedFilters, portList, dispatch);
  } else {
    if (isValidArray(searchResults) && (isValidArray(ffIdsList) || isValidArray(carrierList))) {
      searchResults = searchResults.filter((result) => {
        if (isValidArray(ffIdsList) && isValidArray(carrierList)) {
          return (
            ffIdsList?.includes(result?.ffOrganisation?.id) &&
            carrierList?.includes(result?.carrier?.id?.toString())
          );
        } else {
          return (
            ffIdsList?.includes(result?.ffOrganisation?.id) ||
            carrierList?.includes(result?.carrier?.id?.toString())
          );
        }
      });
    }
    dispatch({
      type: DISCOVER_RATES_SET_FILTERS,
      searchResults,
    });
  }
};
export const getAllDataResetFilter = (apiCall = true, fromURL = false) => async (dispatch) => {
  dispatch({
    type: DISCOVER_RATES_RESET_FILTERS,
  });
  if (apiCall) dispatch(fetchAllData({isSearch: false, resetFreight: true, fromURL}));
};
export const fetchAllData = (
  {isSearch = false,
  resetFreight = false,
  fromURL = false,
  tabChange = false,
  customDataFromQuery = null}
) => async (dispatch, getState) => {
  dispatch({
    isSearch,
    type: DISCOVER_RATES_ENABLE_LOADING,
  });
  isSearch &&
    dispatch({
      type: DISCOVER_RATES_ENABLE_FILTERS_LOADING,
    });
  let apiArray;
  const searchFilters = getState().discoverRatesReducer.searchFilters;
  const fromGridView = searchFilters.fromGridView;
  const prefillData = getState().masterData?.redirectPrefillData;

  if (prefillData) {
    dispatch({
      type: RESET_PREFILL_DATA
    });
  }
  if (customDataFromQuery) {
    apiArray = [
      rateDigitisationDiscoverRates(customDataFromQuery),
      rateDigitisationDiscoverRatesGetFilters(customDataFromQuery),
    ];
  } else {
    const selectedFilters = getState().discoverRatesReducer.selectedFilters;
    const sortByFilters = getState().discoverRatesReducer.sortByFilters;
    const uuid = getState().discoverRatesReducer.uuid;
    const polId = searchFilters.pol?.type !== 'ADDRESS' ? searchFilters.pol?.id : undefined;
    const podId = searchFilters.pod?.type !== 'ADDRESS' ? searchFilters.pod?.id : undefined;
    const containerList = JSON.parse(searchFilters.container || '[]');
    const corgoList = JSON.parse(searchFilters.cargo || '[]');
    const container = containerList.key;
    const cargo = corgoList.key;
    const includeExpiredRates = searchFilters.includeExpiredRates;
    const weight = selectedFilters.weight?.value ? selectedFilters.weight : null;
    const mode = searchFilters?.mode??ModesOfService.FCL;
    const {
      view,
      incoterm,
      movementType,
      shipperTeamId,
      originServices,
      destinationServices,
      grossWeight,
      totalVolume,
      totalVolumetricWeight,
      originCity,
      originState,
      destinationCity,
      destinationState,
      originCountryId,
      destinationCountryId,
      vehicle,
      originGeoRadius,
      destinationGeoRadius,
      polGroupId,
      podGroupId
    } = searchFilters;
    const {
      originServices: selectedOriginServices,
      destinationServices: selectedDestinationServices,
      stuffingType,
      stuffingLocationId,
      destuffingType,
      destuffingLocationId,
      stuffingWeight,
      destuffingWeight,
    } = selectedFilters;
    
    let { shipperOrganisationId } = searchFilters;
    const isNonLinkedShipperSelected = shipperOrganisationId === 'nonLinkedShippers';
    shipperOrganisationId =
      shipperOrganisationId === 'nonLinkedShippers' ? undefined : shipperOrganisationId;
    const fetchApi = view === 'BUY' ? rateDigitisationDiscoverRates : fetchDiscoverSellRates;
    const isStuffingAddress = searchFilters.pol?.type === 'ADDRESS' || (searchFilters?.pol?.addressTypes?.length && searchFilters?.pol?.addressTypes?.includes('STUFFING'));
    const isDeStuffingAddress = searchFilters.pod?.type === 'ADDRESS' || (searchFilters?.pod?.addressTypes?.length && searchFilters?.pod?.addressTypes?.includes('DESTUFFING'));
    const body = {
      ...(isStuffingAddress  ? {} : { polId }),
      ...(isDeStuffingAddress ? {} : { podId }),
      polGroupId,
      podGroupId,
      container,
      priceTrendsIntervalInMonths: 12, // TODO: send this only for Analytics API call; it overrides includeExpiredRates
      includeExpiredRates,
      cargo,
      mode,
      uuid,
      view,
      ...((incoterm && movementType) && {
        incoterm,
        movementType,
        originServices: selectedOriginServices,
        destinationServices: selectedDestinationServices,
        stuffingType,
        stuffingLocationId,
        destuffingType,
        destuffingLocationId,
        stuffingWeight,
        destuffingWeight,
      }),
      ...(shipperTeamId && { shipperTeamId }),
      ...((originServices && destinationServices &&
        (!selectedOriginServices?.length && !selectedDestinationServices?.length)) &&
        { originServices, destinationServices }
      ),
      ...(searchFilters?.fromGridView && {
        isGridView: true,
      }),
      ...(isSearch && {
        isPrimary: true,
      }),
      ...sortByFilters,
      ...(!isSearch && {
        ...selectedFilters,
        weight,
        transitDays:
          (selectedFilters?.transitDays?.min || selectedFilters?.transitDays?.min === 0) &&
          selectedFilters?.transitDays?.max
            ? [selectedFilters?.transitDays?.min, selectedFilters?.transitDays?.max]
            : null,
        freightPrice:
          (selectedFilters?.freightPrice?.min || selectedFilters?.freightPrice?.min === 0) &&
          selectedFilters?.freightPrice?.max
            ? {
                range: [selectedFilters?.freightPrice?.min, selectedFilters?.freightPrice?.max],
                currency: Currency.USD,
              }
            : null,
      }),
      ...(view === 'SELL' && {
        shipperOrganisationId,
        isNonLinkedShipperSelected,
      }),
      grossWeight, 
      totalVolume,
      totalVolumetricWeight,
      
       // NEW LOGIC: Handle city/state based on what was actually set in searchFilters
      // Ensure only one field (city OR state) is set for each location
      ...((searchFilters.mode === ModesOfService.TRAILER && isStuffingAddress) || searchFilters.mode === ModesOfService.DOMESTIC || searchFilters.mode === ModesOfService.RPTL) && {
        ...(originState && !polGroupId && {
          originState,
          originCountryId,
        }),
        ...(originCity && !originState && !polGroupId && {
          originCity,
          originCountryId,
        }),
        ...(destinationState && !podGroupId && {
          destinationState,
          destinationCountryId,
        }),
        ...(destinationCity && !destinationState && !podGroupId && {
          destinationCity,
          destinationCountryId,
        }),
      },
      
      vehicle: (searchFilters.vehicle && searchFilters.mode !== ModesOfService.RPTL) ? {type: searchFilters.vehicle} : undefined,
      originGeoRadius: originGeoRadius?.value ? searchFilters.originGeoRadius : undefined,
      destinationGeoRadius: destinationGeoRadius?.value ? searchFilters.destinationGeoRadius : undefined,
    };
    
    if (isSearch || fromURL) {
      apiArray = [fetchApi(body), rateDigitisationDiscoverRatesGetFilters(body)];
    } else {
      apiArray = [fetchApi(body)];
    }
  }

  const responses: any[] = await Promise.all(apiArray);
  responses.forEach((response, index) => {
    if (!response.isSuccess) {
      dispatch({
        type: DISCOVER_RATES_FETCH_ERROR,
        data: response.errorMessage,
      });
    } else {
      dispatch({
        type: !index ? DISCOVER_RATES_FETCH_DATA : DISCOVER_RATES_FETCH_FILTERS,
        data: responses[index]?.data,
        ...(!index && {
          isSearch,
          resetFreight,
          fromURL,
          tabChange,
          fromGridView,
          customDataFromQuery,
        }),
      });
    }
  });
  dispatch({
    type: DISCOVER_RATES_DISABLE_LOADING,
  });
  dispatch({
    type: DISCOVER_RATES_DISABLE_FILTERS_LOADING,
  });
};
export const setSearchResults = (val) => (dispatch) => {
  dispatch({
    type: DISCOVER_RATES_SET_SEARCH_RESULTS,
    data: val,
  });
};
